import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  enabled?: boolean
  filter: {
    clientIds?: Array<number>
    cameraIds?: Array<number>
    companyIds?: Array<number>
  }
  start: string
  end: string
}

export default function useDashboardSeriesByObjects({filter, enabled, start, end}: Props) {
  const query = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.DASHBOARD_OBJECT_SERIES, filter, start, end],
    queryFn: async () => (await api.reports.getSeriesByObject({filter, start, end})).data.data,
  })

  return query
}
